import router from '../router'

export const toLogin = () => {
  router.replace({
    name: 'Login'
  }).catch((err) => { err })
}

export const toMainPage = () => {
  router.replace({
    name: 'RegistrationSearch'
  }).catch((err) => { err })
}

// export const dev = 'https://loveseven-admin.changelifedev.com'
export const dev = 'https://loveseven-admin-1522e959cb744ed98b59cfe3b5ba4fe9.changelifechurch.com'
export const prod = 'https://loveseven-admin-1522e959cb744ed98b59cfe3b5ba4fe9.changelifechurch.com'